import type { ReactNode } from "react";
import BlogHeader from "@/components/blog/BlogHeader";

type Props = {
  eyebrow?: string;
  title: string;
  children: ReactNode;
};

export default function LegalPage({ eyebrow, title, children }: Props) {
  return (
    <div
      className="fixed inset-0 overflow-y-auto bg-background text-foreground"
      style={{ touchAction: "auto", overscrollBehavior: "auto" }}
    >
      <BlogHeader fallbackBack={{ to: "/info", label: "Info" }} />
      <header className="border-b border-border">
        <div className="max-w-3xl mx-auto px-6 pb-10 pt-6">
          {eyebrow && (
            <div className="text-[10px] tracking-[0.4em] uppercase text-gold/85 mb-3">
              {eyebrow}
            </div>
          )}
          <h1 className="font-serif text-4xl md:text-5xl leading-[1.05]">{title}</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <article
          className="
            text-foreground/80 text-sm md:text-base leading-relaxed
            [&_h2]:font-serif [&_h2]:text-foreground [&_h2]:text-xl [&_h2]:md:text-2xl
            [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:first:mt-0
            [&_p]:mb-4
            [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_ul]:mb-4
            [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-gold
          "
        >
          {children}
        </article>
      </main>
    </div>
  );
}
